import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
const SenceCardE = () => {
    const { t } = useLang('Delta3AirStation.SenceCardE');
    return (
        <section className={`${styles.SenceCardE} range7 GtmModuleData-section`} id="List-sence-G" data-section-id="SenceCardE">
            <div className="title-box">
                <div className="label">{t('label')}</div>
                <div className="title">{t('title')}</div>
                <div className="subtitle">{t('subtitle')}</div>
            </div>
            <div className="content-box">
                <EcoImg alt={t('title')} pc="https://websiteoss.ecoflow.com/upload/image/1761632783637/sence-e-1-pc.jpg" isOpenLazy />
            </div>
            <div className="tips">{t('tips')}</div>
        </section>
    );
};

export default SenceCardE;
